import React from 'react';
import { Button, Typography } from 'antd';
import { EyeOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const BRAND_INDIGO = '#2E2B81';
const BRAND_INDIGO_DEEP = '#1e1b6e';
const BRAND_GREEN = '#00984A';
const BRAND_YELLOW = '#FFC200';

export const LoggedOutHeroMessage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: `linear-gradient(135deg, ${BRAND_INDIGO} 0%, ${BRAND_INDIGO_DEEP} 100%)`,
        padding: '72px 24px 64px',
        textAlign: 'center',
      }}
    >
      {/* Pontos decorativos com as cores da marca */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          marginBottom: 36,
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.3)',
            display: 'inline-block',
          }}
        />
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: BRAND_GREEN,
            display: 'inline-block',
          }}
        />
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: BRAND_YELLOW,
            display: 'inline-block',
          }}
        />
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.3)',
            display: 'inline-block',
          }}
        />
      </div>

      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <Title
          level={1}
          style={{
            color: '#ffffff',
            fontSize: 'clamp(22px, 4vw, 40px)',
            lineHeight: 1.25,
            marginBottom: 20,
            fontWeight: 700,
            textWrap: 'balance' as React.CSSProperties['textWrap'],
          }}
        >
          Acreditamos que a opinião só tem valor quando é livre, confiável e respeitada.
        </Title>

        <Paragraph
          style={{
            color: 'rgba(255, 255, 255, 0.72)',
            fontSize: 16,
            lineHeight: 1.7,
            marginBottom: 44,
          }}
        >
          Participe de pesquisas de opinião pública e contribua para decisões mais justas e transparentes. 
          Transparência, rastreabilidade e auditabilidade são os pilares que garantem a confiança em cada pesquisa realizada.
        </Paragraph>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            size="large"
            style={{
              borderColor: 'rgba(255,255,255,0.45)',
              color: '#ffffff',
              background: 'transparent',
              height: 44,
              paddingInline: 24,
            }}
            onClick={() => {
              document.getElementById('survey-lists')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Ver pesquisas
          </Button>
          <Button
            size="large"
            
            style={{
              borderColor: 'rgba(255,255,255,0.45)',
              color: '#ffffff',
              background: 'transparent',
              height: 44,
              paddingInline: 24,
            }}
            onClick={() => navigate('/faq')}
          >
            Perguntas frequentes
          </Button>
          <Button
            size="large"
            style={{
              background: BRAND_YELLOW,
              borderColor: BRAND_YELLOW,
              color: '#1a1a1a',
              fontWeight: 600,
              height: 44,
              paddingInline: 24,
            }}
            onClick={() => navigate('/register')}
          >
            Criar conta
          </Button>
        </div>
      </div>

      {/* Trust signals — rastreabilidade em 3 pontos */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap', marginTop: 28 }}>
        {[
          { icon: <SafetyCertificateOutlined />, text: 'Pesquisas verificadas' },
          { icon: <LockOutlined />, text: 'Resposta rastreável' },
          { icon: <EyeOutlined />, text: 'Resultado auditável' },
        ].map(({ icon, text }) => (
          <div
            key={text}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '5px 14px',
              background: 'rgba(255,255,255,0.10)',
              borderRadius: 20,
              fontSize: 13,
              color: 'rgba(255,255,255,0.80)',
            }}
          >
            <span style={{ color: BRAND_GREEN, fontSize: 14 }}>{icon}</span>
            {text}
          </div>
        ))}
      </div>

      {/* Barra decorativa com gradiente verde → amarelo */}
      <div
        style={{
          height: 4,
          width: 80,
          margin: '28px auto 0',
          background: `linear-gradient(90deg, ${BRAND_GREEN}, ${BRAND_YELLOW})`,
          borderRadius: 2,
        }}
      />
    </div>
  );
};
